import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  ReferenceField,
  FilterLiveSearch,
  SelectInput,
  DateInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
} from 'react-admin';
import { createEmptyStateComponent } from '../../components/createEmptyStateComponent';
import { PageWrapper } from '../../components/PageWrapper';

const fuelTypes = [
  { id: 'DIESEL', name: 'Diesel' },
  { id: 'GAS', name: 'Gasoline' },
  { id: 'DEF', name: 'Diesel Exhaust Fluid' },
  { id: 'HYDRAULIC', name: 'Hydraulic Fluid' },
  { id: 'ENGINE_OIL', name: 'Engine Oil' },
  { id: 'OTHER', name: 'Other' }
];

const CostField = ({ source }: { source: string }) => {
  const record = useRecordContext();
  const value = record?.[source];
  
  if (!value) return <span>-</span>;
  
  return (
    <span>${Number(value).toFixed(2)}</span>
  );
};

const FuelEmptyState = createEmptyStateComponent('fuel records');

const FuelListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const useFuelFilters = () => {
  return React.useMemo(
    () => [
      <FilterLiveSearch key="vendor" source="vendor" placeholder="Search by vendor..." />,
      <SelectInput 
        key="fuelType"
        source="fuelType" 
        choices={fuelTypes} 
        label="Fuel Type"
        alwaysOn
      />,
      <DateInput key="fuelDate" source="fuelDate" label="Fuel Date" />,
    ],
    []
  );
};

export const EquipmentFuelList = () => {
  const filters = useFuelFilters();
  
  return (
    <PageWrapper title="Equipment Fuel">
      <List
        perPage={25}
        sort={{ field: 'fuelDate', order: 'DESC' }}
        filters={filters}
        actions={<FuelListActions />}
        empty={<FuelEmptyState />}
      >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" sortable={false} />
        <ReferenceField source="equipmentId" reference="equipment">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="fuelDate" />
        <TextField source="fuelType" />
        <NumberField source="quantity" />
        <CostField source="unitCost" />
        <CostField source="totalCost" />
        <NumberField source="mileage" label="Odometer (KM)" />
        <NumberField source="engineHours" />
        <TextField source="location" />
        <TextField source="vendor" />
        <DateField source="createdAt" />
      </Datagrid>
    </List>
    </PageWrapper>
  );
};